import { getLocations } from "@/api/locations";

export default {
  async getLocations({ commit }) {
    const response = await getLocations();
    commit("setLocations", response);
  }
};
